"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _StringUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/StringUtility"));

var _ServiceSettings = _interopRequireDefault(require("../../../ServiceSettings"));

var _TypeCodeToGlobalTypeMapJson = _interopRequireDefault(require("./TypeCodeToGlobalTypeMap.json.js"));

var _LocalizationServiceFacade = _interopRequireDefault(require("../../../facade/LocalizationServiceFacade"));

var _EcommerceCartDataSourceConstant = _interopRequireDefault(require("../../../constant/EcommerceCartDataSourceConstant"));

var _LocalizationUtility = _interopRequireDefault(require("../../../util/LocalizationUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ENERGY_CLASSES = {
  'A+++': 1,
  'A++': 1,
  'A+': 1,
  A: 1,
  B: 1,
  C: 1,
  D: 1,
  E: 1
};
var IMAGE_SIZES = {
  S1: 40,
  S2: 110,
  S3: 250,
  S4: 500,
  S5: 2000
};
/**
 * This class is used for parsing data recieved from RetailItemComm.
 */

var DexfWebPlannerParser = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {ArticleServiceConfig} config Service config.
   */
  function DexfWebPlannerParser(config) {
    _classCallCheck(this, DexfWebPlannerParser);

    this._productInfoPageUrl = config.productInfoPageUrl;
    this._fields = config.fields;
  }
  /**
   * Parses data recieved from RetailItemComm service.
   *
   * @param {object} data Incomming data.
   * @returns {object[]} Parsed items.
   */


  _createClass(DexfWebPlannerParser, [{
    key: "parse",
    value: function parse(data) {
      if (data) {
        return this._parseItemsData(data);
      }

      return [];
    }
    /**
     * Parses item data recieved from RetailItemComm service.
     *
     * @param {object[]} items Array of items.
     * @returns {object[]} Parsed items.
     */

  }, {
    key: "_parseItemsData",
    value: function () {
      var _parseItemsData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(items) {
        var _this = this;

        var itemsData, _iterator, _step, item;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!items) {
                  _context2.next = 20;
                  break;
                }

                itemsData = [];
                _iterator = _createForOfIteratorHelper(items);
                _context2.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 11;
                  break;
                }

                item = _step.value;

                if (!(item.valid === true)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var content, data, itemNoLocal, prices, priceUnit;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          content = item.content;
                          data = {
                            isNew: content.isNew || false,
                            // Not supported by DEXF
                            RelatedItems: [] // Not supported by DEXF

                          };

                          if (content.complianceLabel) {
                            data.complianceLabel = content.complianceLabel;
                          }

                          if (content.complianceTechnical) {
                            data.complianceTechnical = content.complianceTechnical;
                          }

                          if (content.itemNoGlobal !== undefined) {
                            data.GlobalID = String(content.itemNoGlobal);
                          }

                          if (content.itemNoLocal !== undefined || data.GlobalID) {
                            itemNoLocal = content.itemNoLocal ? String(content.itemNoLocal) : data.GlobalID;
                            data.LocalID = itemNoLocal;
                            data.ArticleNumber = _this._getArticleNumber(itemNoLocal);
                            data.ID = itemNoLocal;

                            if (!data.GlobalID) {
                              data.GlobalID = data.LocalID;
                            }
                          }

                          if (content.itemType !== undefined) {
                            data.ItemType = content.itemType.toUpperCase();
                          }

                          if (data.LocalID && data.ItemType) {
                            data.ProductInfoPageURL = _this._getProductInfoUrl(data.LocalID, data.ItemType);
                          }

                          if (content.name !== undefined || !_this._fields) {
                            data.ProductName = content.name;
                          }

                          if (content.typeName !== undefined || !_this._fields) {
                            data.ProductTypeName = content.typeName ? content.typeName.charAt(0).toUpperCase() + content.typeName.slice(1) : '';
                          }

                          if (content.validDesignText !== undefined || !_this._fields) {
                            data.ValidDesignText = content.validDesignText;
                          }

                          if (content.isBreathTakingItem !== undefined || !_this._fields) {
                            data.isBreathTakingItem = content.breathTakingItem;
                          }

                          if (!(content.priceInformation !== undefined || !_this._fields)) {
                            _context.next = 22;
                            break;
                          }

                          prices = _this._getPrices(content.priceInformation);
                          _context.next = 16;
                          return _this._isEcommerceCartDataSourceEnabled().then(function (value) {
                            data.isOnlineSellable = value;
                          });

                        case 16:
                          data.Prices = prices.prices;
                          data.isFamilyPrice = prices.isFamilyPrice;
                          data.isTemporaryFamilyPrice = prices.isTemporaryFamilyPrice;
                          data.isNewLowerPrice = prices.isNewLowerPrice;
                          data.isTimeRestrictedOffer = prices.isTimeRestrictedOffer;
                          data.ItemFees = _this._getRetailItemFees(content.priceInformation);

                        case 22:
                          if (content.priceUnit !== undefined || !_this._fields) {
                            priceUnit = Array.isArray(content.priceUnit) ? content.priceUnit[0] : content.priceUnit;
                            data.PriceUnitText = priceUnit && priceUnit.textMetric ? priceUnit.textMetric : '';
                            data.PriceUnitTextEn = priceUnit && priceUnit.typeCode === '00061' ? 'pack' : '';
                            data.PriceUnitFactor = priceUnit && priceUnit.factorMetric ? priceUnit.factorMetric : 1;
                          }

                          if (content.measure !== undefined || !_this._fields) {
                            data.Measurements = _this._getMeasurements(content.measure);
                          }

                          if (content.packageMeasure !== undefined || !_this._fields) {
                            data.PackageMeasurements = _this._getPackageMeasurements(content.packageMeasure);
                          }

                          if (content.measureReference !== undefined || !_this._fields) {
                            data.MeasureReferenceText = _this._getMeasureReferenceText(content.measureReference);
                          }

                          if (content.technicalInformation !== undefined || !_this._fields) {
                            data.TechnicalInformation = _this._getTechnicalInformationList(content.technicalInformation);
                            data.EnergyClass = _this._getEnergyClass(data.TechnicalInformation);
                          }

                          if (content.goodToKnow !== undefined || !_this._fields) {
                            data.GoodToKnow = _this._getGoodToKnowList(content.goodToKnow);
                          }

                          if (content.customerBenefit !== undefined || !_this._fields) {
                            data.CustomerBenefit = _this._getCustomerBenefitList(content.customerBenefit);
                          }

                          if (content.customerBenefitSummary !== undefined || !_this._fields) {
                            data.CustomerBenefitSummary = content.customerBenefitSummary ? content.customerBenefitSummary.text : '';
                          }

                          if (content.image !== undefined || !_this._fields) {
                            data.Images = _this._getImages(content.image);
                          }

                          if (content.genericProduct !== undefined || !_this._fields) {
                            data.GenericProducts = _this._getGenericProducts(content.genericProduct);
                          }

                          if (content.careInstruction !== undefined || !_this._fields) {
                            data.CareInstructions = _this._getCareInstructionList(content.careInstruction);
                          }

                          if (content.customerMaterial !== undefined || !_this._fields) {
                            data.CustomerMaterials = _this._getCustomerMaterialList(content.customerMaterial);
                          }

                          if (content.peopleAndPlanet !== undefined || !_this._fields) {
                            data.PeopleAndPlanet = _this._getPeopleAndPlanet(content.peopleAndPlanet);
                          }

                          if (content.filterAttribute !== undefined || !_this._fields) {
                            data.FilterAttributes = _this._getFilterAttributes(content.filterAttribute);
                          }

                          Object.defineProperty(data, 'MeassureInformation', {
                            get: function get() {
                              _Console.default.warn('RetailItemParser: The property with name "MeassureInformation" is deprecated. Please use "Measurements" instead');

                              return _this._getMeasurements(content.measure);
                            }
                          });
                          Object.defineProperty(data, 'CustomerEnvironments', {
                            get: function get() {
                              _Console.default.warn('RetailItemParser: The property with name "CustomerEnvironments" is deprecated. Please use "PeopleAndPlanet" instead');

                              return _this._getCustomerEnvironmentList(content.peopleAndPlanet);
                            }
                          });

                          if (data.ItemType === 'SPR') {
                            data.ChildItems = _this._getChildItems(content.child);
                          }

                          itemsData.push(data);

                        case 40:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })(), "t0", 9);

              case 9:
                _context2.next = 5;
                break;

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](3);

                _iterator.e(_context2.t1);

              case 16:
                _context2.prev = 16;

                _iterator.f();

                return _context2.finish(16);

              case 19:
                return _context2.abrupt("return", itemsData);

              case 20:
                return _context2.abrupt("return", []);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 13, 16, 19]]);
      }));

      function _parseItemsData(_x) {
        return _parseItemsData2.apply(this, arguments);
      }

      return _parseItemsData;
    }()
    /**
     * Returns product info URL.
     *
     * @param {string} itemNoLocal Local item number.
     * @param {string} itemType Price information.
     * @returns {string} Product info URL.
     */

  }, {
    key: "_getProductInfoUrl",
    value: function _getProductInfoUrl(itemNoLocal, itemType) {
      // M2 has no redirect for /spr/S12345678 so we need to remove the S prefix for mobile to support SPR urls in m2.
      if (this._productInfoPageUrl.includes('{articleType}')) {
        return this._productInfoPageUrl.replace('{articleID}', itemNoLocal).replace('{articleType}', itemType.toLowerCase());
      }

      if (itemType === 'SPR') {
        return this._productInfoPageUrl.replace('{articleID}', itemNoLocal).replace('{lowerCaseSprPrefix}', 's').replace('{upperCaseSprPrefix}', 'S');
      }

      return this._productInfoPageUrl.replace('{articleID}', itemNoLocal).replace('{lowerCaseSprPrefix}', '').replace('{upperCaseSprPrefix}', '');
    }
    /**
     * Returns prices.
     *
     * @param {object} priceInformation Price information.
     * @returns {object} Prices.
     */

  }, {
    key: "_getPrices",
    value: function _getPrices(priceInformation) {
      var prices = {};
      var isFamilyPrice = false;
      var isTemporaryFamilyPrice = false;
      var isNewLowerPrice = false;
      var isTimeRestrictedOffer = false;

      if (priceInformation && priceInformation.salesPrice) {
        var salesPrices = priceInformation.salesPrice;

        var _iterator2 = _createForOfIteratorHelper(salesPrices),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var priceItem = _step2.value;

            var priceObj = this._getPriceObject(priceItem);

            if (priceObj) {
              if (priceItem.typeCode === 'IKEAFamilySalesUnitPrice') {
                isFamilyPrice = true;
                prices.FamilyPrice = priceObj;

                if (priceItem.changeReason && priceItem.changeReason === 'Temporary') {
                  isTemporaryFamilyPrice = true;
                }
              } else if (priceItem.changeReason && priceItem.changeReason === 'NewLowerPrice') {
                isNewLowerPrice = true;
                prices.NormalPrice = priceObj;
              } else if (priceItem.changeReason && priceItem.changeReason === 'TimeRestrictedOffer') {
                isTimeRestrictedOffer = true;
                prices.NormalPrice = priceObj;

                if (priceItem.previousSalesPrice) {
                  prices.RegularPrice = this._getPriceObject(Object.assign({}, priceObj, priceItem.previousSalesPrice));
                }
              } else if (salesPrices.length > 1) {
                prices.RegularPrice = priceObj;
              } else {
                prices.NormalPrice = priceObj;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (!prices.NormalPrice && prices.RegularPrice) {
          prices.NormalPrice = prices.RegularPrice;
        }
      }

      return {
        prices: prices,
        isFamilyPrice: isFamilyPrice,
        isTemporaryFamilyPrice: isTemporaryFamilyPrice,
        isNewLowerPrice: isNewLowerPrice,
        isTimeRestrictedOffer: isTimeRestrictedOffer
      };
    }
    /**
     * Checks if an item is new.
     *
     * @param {object} item Item to check.
     * @returns {boolean} TRUE if new.
     */

  }, {
    key: "_isNewItem",
    value: function _isNewItem(item) {
      // DEXF does not support this
      return item.isNew || false;
    }
    /**
     * Checks if an item is onlineSaleable.
     *
     * @returns {boolean} Disabled or not.
     */

  }, {
    key: "_isEcommerceCartDataSourceEnabled",
    value: function () {
      var _isEcommerceCartDataSourceEnabled2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var localizationData, value;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _LocalizationServiceFacade.default.getData();

              case 2:
                localizationData = _context3.sent;
                value = _LocalizationUtility.default.getAppSettingValue(localizationData, 'eCommerceCartDataSource');
                return _context3.abrupt("return", value === _EcommerceCartDataSourceConstant.default.disabled ? false : true);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _isEcommerceCartDataSourceEnabled() {
        return _isEcommerceCartDataSourceEnabled2.apply(this, arguments);
      }

      return _isEcommerceCartDataSourceEnabled;
    }()
    /**
     * Returns the technical information list.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} Technical information list.
     */

  }, {
    key: "_getTechnicalInformationList",
    value: function _getTechnicalInformationList(data) {
      if (data && Array.isArray(data)) {
        var info = [];

        var _iterator3 = _createForOfIteratorHelper(data),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            info.push({
              RangeNo: item.rangeCode,
              Number: item.typeCode,
              Text: item.typeName,
              Value: item.valueMetric,
              Sort: item.sortNo
            });
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        if (info.length > 0) {
          return info.sort(function (a, b) {
            return a.Sort > b.Sort ? 1 : b.Sort > a.Sort ? -1 : 0;
          });
        } else {
          return null;
        }
      }

      return null;
    }
    /**
     * Returns the energy class.
     *
     * @param {object[]} items Items to parse.
     * @returns {string|null} Energy class.
     */

  }, {
    key: "_getEnergyClass",
    value: function _getEnergyClass(items) {
      var energyClass = null;

      if (items && items.length > 0) {
        var _iterator4 = _createForOfIteratorHelper(items),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var item = _step4.value;

            if (typeof item.Value === 'string') {
              if (_ServiceSettings.default.retailItemEfficiencyClasses && _ServiceSettings.default.retailItemEfficiencyClasses.includes(item.Number)) {
                energyClass = item.Value;
                break;
              } else if (ENERGY_CLASSES[item.Value]) {
                energyClass = item.Value;
                break;
              } else if (process && process.env && process.env.NODE_ENV === 'development' && ENERGY_CLASSES[item.Value.split(' ')[0]]) {
                _Console.default.warn('ArticleService: Potential energy class missed. Number: ' + item.Number + ', Value: ' + item.Value + '');
              }
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return energyClass;
    }
    /**
     * Returns the price object.
     *
     * @param {object} [priceObj] Price object. Returns null if not set.
     * @returns {object|null} Price object.
     */

  }, {
    key: "_getPriceObject",
    value: function _getPriceObject(priceObj) {
      if (!priceObj || !priceObj.priceInclTax) {
        return null;
      }

      return {
        Currency: priceObj.currencyCode,
        Price: Number(priceObj.priceInclTax),
        PriceExclTax: priceObj.priceExclTax ? Number(priceObj.priceExclTax) : null,
        ValidFrom: priceObj.changeReason && priceObj.validFromText ? priceObj.validFromText : null,
        ValidTo: priceObj.changeReason && priceObj.validToText ? priceObj.validToText : null,
        isTemporary: priceObj.changeReason && priceObj.validFromText && priceObj.validToText ? true : false
      };
    }
    /**
     * Returns the article number.
     *
     * @param {string} articleId Article number.
     * @returns {string} Article number.
     */

  }, {
    key: "_getArticleNumber",
    value: function _getArticleNumber(articleId) {
      var articleNumber = String(articleId).replace('S', '');

      if (articleNumber.length === 8) {
        return articleNumber.substr(0, 3) + '.' + articleNumber.substr(3, 3) + '.' + articleNumber.substr(6);
      }

      return articleNumber;
    }
    /**
     * Returns the global type name based on type code.
     *
     * @param {string} typeCode Type code.
     * @returns {string} Global type name.
     */

  }, {
    key: "_getGlobalType",
    value: function _getGlobalType(typeCode) {
      return _TypeCodeToGlobalTypeMapJson.default[typeCode] || null;
    }
    /**
     * Returns measurements.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} List of measurements.
     */

  }, {
    key: "_getMeasurements",
    value: function _getMeasurements(data) {
      var info = [];

      if (data && Array.isArray(data)) {
        var _iterator5 = _createForOfIteratorHelper(data),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var item = _step5.value;
            info.push({
              Type: item.typeName,
              GlobalType: this._getGlobalType(item.typeCode),
              MetricValue: item.textMetric,
              ImperialValue: item.textImperial,
              Sort: item.sortNo
            });
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      return info;
    }
    /**
     * Returns package measurements.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} List of package measurements.
     */

  }, {
    key: "_getPackageMeasurements",
    value: function _getPackageMeasurements(data) {
      var info = [];
      var measurements = {};

      if (data && data.package && Array.isArray(data.package)) {
        var _iterator6 = _createForOfIteratorHelper(data.package),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var item = _step6.value;
            var keys = Object.keys(item);

            for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
              var key = _keys[_i];

              if (!key.includes('Gross') || !keys.includes(key.replace('Gross', 'Net'))) {
                for (var _i2 = 0, _arr = ['Imperial', 'Metric']; _i2 < _arr.length; _i2++) {
                  var measure = _arr[_i2];

                  if (key.includes(measure)) {
                    var parsedKey = key.replace(measure, '').replace('Net', '').replace('Gross', '');

                    var kebabKey = _StringUtility.default.camelToKebabCase(parsedKey).replace(/-/g, '_').toUpperCase();

                    measurements[kebabKey] = measurements[kebabKey] || {};
                    measurements[kebabKey][measure] = item[key];
                  }
                }
              }
            }

            for (var _i3 = 0, _Object$keys = Object.keys(measurements); _i3 < _Object$keys.length; _i3++) {
              var _key = _Object$keys[_i3];
              info.push({
                ConsumerPackNumber: item.no || 1,
                Type: _key,
                MetricValue: measurements[_key].Metric,
                ImperialValue: measurements[_key].Imperial,
                Sort: 1
              });
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }

      return info;
    }
    /**
     * Returns measure reference text.
     *
     * @param {object} data Data to parse.
     * @returns {object} Object with measure reference text.
     */

  }, {
    key: "_getMeasureReferenceText",
    value: function _getMeasureReferenceText(data) {
      var text = {
        Imperial: '',
        Metric: ''
      };

      if (data) {
        text.Imperial = data.textImperial || '';
        text.Metric = data.textMetric || '';
      }

      return text;
    }
    /**
     * Returns list of good to know text.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} List of good to know text.
     */

  }, {
    key: "_getGoodToKnowList",
    value: function _getGoodToKnowList(data) {
      if (data && Array.isArray(data)) {
        var list = [];

        var _iterator7 = _createForOfIteratorHelper(data),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var item = _step7.value;
            list.push({
              Type: item.typeName,
              //TypeNo: item.goodToKnowTypeNo, not implemented by DEXF yet
              Text: item.text,
              Sort: item.sortNo
            });
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        return list;
      }

      return null;
    }
    /**
     * Returns list of customer benefits.
     *
     * @param {object} data Data to parse.
     * @returns {object[]|null} List of customer benefits.
     */

  }, {
    key: "_getCustomerBenefitList",
    value: function _getCustomerBenefitList(data) {
      if (data && Array.isArray(data)) {
        var list = [];

        var _iterator8 = _createForOfIteratorHelper(data),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var item = _step8.value;
            list.push({
              Text: item.text,
              Sort: item.sortNo
            });
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return list;
      }

      return null;
    }
    /**
     * Returns retail item fees.
     *
     * @param {object} data Data to parse.
     * @returns {object[]} Array with retail item fees items.
     */

  }, {
    key: "_getRetailItemFees",
    value: function _getRetailItemFees(data) {
      var fees = [];

      if (data && Array.isArray(data.fees)) {
        var _iterator9 = _createForOfIteratorHelper(data.fees),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var item = _step9.value;
            fees.push({
              Type: item.typeCode,
              Amount: item.amount,
              CurrencyCode: item.currencyCode
            });
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }

      return fees;
    }
    /**
     * Returns image data.
     *
     * @param {object} data Image data to parse.
     * @returns {object[]} Image data.
     */

  }, {
    key: "_getImages",
    value: function _getImages(data) {
      if (data && Array.isArray(data)) {
        var images = {
          S1: [],
          S2: [],
          S3: [],
          S4: [],
          S5: []
        };

        var _iterator10 = _createForOfIteratorHelper(data),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var item = _step10.value;

            if (item.url) {
              images[item.size].push({
                Size: item.size,
                Usage: 'INTERNET',
                TypeName: item.typeName,
                Url: item.url,
                Width: IMAGE_SIZES[item.size],
                Height: IMAGE_SIZES[item.size],
                SortNo: item.sortNo || 100 + images[item.size].length // give images without sortNo a higher value to make them appear last in array

              });
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        for (var size in images) {
          images[size] = images[size].sort(function (a, b) {
            return a.SortNo > b.SortNo ? 1 : b.SortNo > a.SortNo ? -1 : 0;
          });
        }

        return images;
      }

      return {};
    }
    /**
     * Returns child items.
     *
     * @param {object[]} children Children to parse.
     * @returns {object[]} Array of child items.
     */

  }, {
    key: "_getChildItems",
    value: function _getChildItems(children) {
      if (children && Array.isArray(children)) {
        var items = [];

        var _iterator11 = _createForOfIteratorHelper(children),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var item = _step11.value;
            var itemType = item.itemId ? item.itemId.split('-')[0] : 'ART';
            var itemNo = item.itemId ? item.itemId.split('-')[1] : null;
            items.push({
              ID: itemNo,
              GlobalID: null,
              LocalID: itemNo,
              ItemType: itemType,
              Quantity: item.quantity || 1,
              ArticleNumber: itemNo ? this._getArticleNumber(itemNo) : null
            });
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }

        return items;
      }

      return [];
    }
    /**
     * Returns child items.
     *
     * @param {object[]} products Products to parse.
     * @returns {object[]} Array of generic products items.
     */

  }, {
    key: "_getGenericProducts",
    value: function _getGenericProducts(products) {
      if (products && Array.isArray(products)) {
        var items = [];

        var _iterator12 = _createForOfIteratorHelper(products),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var item = _step12.value;
            items.push({
              Code: item.code,
              TypeCode: item.typeCode,
              TypeName: item.typeName,
              Value: item.selectionValue
            });
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }

        return items;
      }

      return [];
    }
    /**
     * Returns care instructions.
     *
     * @param {object[]} careInstruction Data to parse.
     * @returns {string[]|null} List of care instructions.
     */

  }, {
    key: "_getCareInstructionList",
    value: function _getCareInstructionList(careInstruction) {
      return Array.isArray(careInstruction) ? careInstruction.map(function (item) {
        return item.text;
      }) : null;
    }
    /**
     * Returns customer materials.
     *
     * @param {object[]} customerMaterial Data to parse.
     * @returns {object[]|null} List of customer materials.
     */

  }, {
    key: "_getCustomerMaterialList",
    value: function _getCustomerMaterialList(customerMaterial) {
      return Array.isArray(customerMaterial) ? customerMaterial.map(function (material) {
        return {
          TextPart: material.textPart || null,
          TextType: material.textType || null,
          Text: material.text
        };
      }) : null;
    }
    /**
     * Returns people and planet.
     *
     * @param {object[]} peopleAndPlanet Data to parse.
     * @returns {string[]|null} List of people and planet texts.
     */

  }, {
    key: "_getPeopleAndPlanet",
    value: function _getPeopleAndPlanet(peopleAndPlanet) {
      return Array.isArray(peopleAndPlanet) ? peopleAndPlanet.map(function (item) {
        return item.text;
      }) : [];
    }
    /**
     * Returns customer environments.
     *
     * @param {object} peopleAndPlanet Data to parse.
     * @returns {object[]|null} List of customer environments.
     */

  }, {
    key: "_getCustomerEnvironmentList",
    value: function _getCustomerEnvironmentList(peopleAndPlanet) {
      return Array.isArray(peopleAndPlanet) ? peopleAndPlanet.map(function (item) {
        return {
          ProductType: null,
          Texts: [item.text]
        };
      }) : [];
    }
    /**
     * Returns filter attributes.
     *
     * @param {object[]} filterAttributes Filter attributes to parse.
     * @returns {object[]} Array of generic filter attributes.
     */

  }, {
    key: "_getFilterAttributes",
    value: function _getFilterAttributes(filterAttributes) {
      if (filterAttributes && Array.isArray(filterAttributes)) {
        var items = [];

        var _iterator13 = _createForOfIteratorHelper(filterAttributes),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var item = _step13.value;
            items.push({
              HeaderCode: item.headerCode,
              HeaderText: item.headerText,
              Value: item.value,
              ValueCode: item.valueCode
            });
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }

        return items;
      }

      return [];
    }
  }]);

  return DexfWebPlannerParser;
}();

exports.default = DexfWebPlannerParser;